<mat-card>
  <mat-card-content class="card">
    <div
      class="filter-container"
      *ngIf="{
        programsData: (programsData$ | async),
        isProgramDataLoading: (programsLoading$ | async),
        isScheduleTab: (isScheduleTab$ | async),
        regViewConfig: (regViewConfig$ | async)
      } as vm"
    >
      <div
        class="filter-container__left"
        [style.padding-bottom]="vm.isScheduleTab ? '0' : '1.1rem'"
        [style.width]="vm.programsData && vm.isScheduleTab ? '100%' : !vm.programsData && !vm.isScheduleTab ? '50%' : '66.6%'"
      >
        <!-- Programs Dropdown -->
        <lib-ngx-dropdown
          *ngIf="vm.programsData && vm.programsData.length > 0"
          #ngx_program_dropdown
          data-cy="programs-filter"
          [options]="vm.programsData"
          [selectedObject]="selectedProgramFormControl"
          [border]="true"
          [multiple]="false"
          [invalid]="false"
          [required]="false"
          [disabled]="!!vm.isProgramDataLoading"
          [title]="'COM.FILTERS.PROGRAMS' | translate"
          [hasInternalReset]="false"
          [hint]="''"
          [width]="'100%'"
          [style.width]="vm.isScheduleTab ? '33%' : '50%'"
          class="filter-container__left--dropdown fdr-select-scope"
        >
        </lib-ngx-dropdown>

        <!-- Registrations Dropdown -->
        <lib-ngx-dropdown
          #ngx_reg_dropdown
          data-cy="registration-filter"
          [options]="registrationsData$ | async"
          [selectedObject]="selectedRegFormControl"
          [border]="true"
          [multiple]="false"
          [invalid]="false"
          [required]="false"
          [disabled]="false"
          [title]="'COM.FILTERS.REGISTRATIONS' | translate"
          [hint]="''"
          [hasInternalReset]="false"
          [width]="'100%'"
          [style.width]="vm.programsData && vm.isScheduleTab ? '33%' : !vm.programsData && !vm.isScheduleTab ? '100%' : '50%'"
          class="filter-container__left--dropdown fdr-select-scope"
        >
        </lib-ngx-dropdown>

        <!-- Date/Week Picker (Dynamic based on graph_view) -->
        <lib-ngx-date-range-picker
          #ngx_drp
          data-cy="datepicker-filter"
          [datePickerType]="datePickerType()"
          [title]="'COM.FILTERS.TIME_PERIOD' | translate"
          [border]="true"
          [isHint]="true"
          [hint]="datePickerHint()"
          [format]="datePickerFormat()"
          [disabled]="false"
          [invalid]="false"
          [style.width]="vm.programsData ? '33%' : '50%'"
          [style.display]="!vm.isScheduleTab ? 'none' : 'inline'"
          [ngClass]="{ 'mr-20-bottom': datePickerType() === datePickerEnum.DatePicker }"
          class="filter-container__left--datePicker fdr-select-scope"
          [selectedDate]="datePickerType() === datePickerEnum.DatePicker ? selectedFromDayPickerFormControl : selectedFromWeekPickerFormControl"
        >
        </lib-ngx-date-range-picker>
      </div>

      <!-- Apply Button -->
      <div class="filter-container__right">
        <span
          [matTooltip]="applyButtonDisabled() ? ('COM.FILTERS.APPLY_DISABLED' | translate) : ''"
          [matTooltipDisabled]="!applyButtonDisabled()"
          matTooltipPosition="below"
        >
          <button
            mat-flat-button
            color="primary"
            class="round-button apply-btn"
            data-cy="filter-apply-btn"
            [disabled]="applyButtonDisabled()"
            (click)="apply()"
          >
            <b>{{ 'COM.BUTTONS.APPLY' | translate }}</b>
          </button>
        </span>
      </div>
    </div>
  </mat-card-content>
</mat-card>
